import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axiosInstance from '../utils/axios'; 
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import "../css/Register.css";

function Register() {
  const [setlang, setLang] = useState("fa");
  const { lang } = useParams();
  const [status, setStatus] = useState(null);
  const [profilePicture, setProfilePicture] = useState(null);
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [errMessage, setErrMessage] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    password2: '',
    accepted_tnc: '',
  });
  
  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleImageChange = (e) => {
    if (e.target.files.length > 0) {
      setProfilePicture(e.target.files[0]); 
    }
  };

  const handleCheckBox = (e) => {
    const { name, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({ ...prev, [name]: checked }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });
      if (profilePicture) {
        formDataToSend.append("profile_picture", profilePicture);
      }
      await axiosInstance.post("register/", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setSuccess(true);
      setProfilePicture(null);
      if (setlang === "en") {
        setStatus("Thank you for your registration, you may now enter your profile.");
        setErrMessage(null)
      } else {
        setStatus("ثبت نام با موفقیت انجام شد. حالا می‌تونی وارد حساب کاربریت بشی");
        setErrMessage(null)
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err);
        setConsoleError(JSON.stringify(err.response.data));
        setErrMessage(setlang === "en"?"This username already exists, please consider a different username":"این نام کاربری استفاده شده، لطفا نام کاربری دیگری انتخاب کن")

      } else {
        setError(err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])
  
  console.log(consoleError)
  return (
    <>
      <NavbarLog />
      <div className="reg-page">
        {setlang === "en" ? 
        <div className="registration-container">
        <h2 className= "registration-heading">Register</h2>
          {success && <p style={{ color: 'green' }}>Registration successful! You can now log in.</p>}
          {errMessage && <pre style={{ color: 'red' }}>{errMessage}</pre>}
          <form className="form-group" onSubmit={handleSubmit}>
            <input
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Username"
              required
            /><br />
            <input
              name="first_name"
              value={formData.first_name}
              onChange={handleChange}
              placeholder="Fist Name"
              required
            /><br />
            <input
              name="last_name"
              value={formData.last_name}
              onChange={handleChange}
              placeholder="Last Name"
              required
            /><br />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email"
              required
            /><br />
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password"
              required
            /><br />
            <input
              type="password"
              name="password2"
              value={formData.password2}
              onChange={handleChange}
              placeholder="Confirm Password"
              required
            /><br />
            <label>Profile Image
              <input type="file" accept="image/*" onChange={handleImageChange} placeholder="Insert Image"/>
            </label>
            <button type="submit" className='button-register' disabled={loading} >{loading ? 'Registering...' : 'Register'}</button>
            <label className="tnc-checkbox" style={{direction:"ltr"}}>
              <input
                name="accepted_tnc"
                type="checkbox"
                checked={formData.accepted_tnc}
                onChange={handleCheckBox}
                required
                />
              I accept the <Link to={`/${lang}/our-terms-and-conditions`}>Terms & Conditions</Link>
            </label>
          </form>
          <div className='login-text' >
          If you already have an account, please <Link to={`/${lang}/login`}>login here</Link>!
          </div>
        </div>
        :
        <div className="registration-container">
          <h2 className= "registration-heading">ثبت نام</h2>
            {success && <p style={{ color: 'green', marginBottom:'10px'  }}>ثبت نام با موفقیت انجام شد. حالا می‌تونی وارد حساب کاربریت بشی</p>}
            {errMessage && <pre style={{ color: 'red', marginBottom:'10px' }}>{errMessage}</pre>}
            <form className="form-group-fa" onSubmit={handleSubmit}>
              <input
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="نام کاربری"
                required
              /><br />
              <input
                name="first_name"
                value={formData.first_name}
                onChange={handleChange}
                placeholder="نام"
                required
              /><br />
              <input
                name="last_name"
                value={formData.last_name}
                onChange={handleChange}
                placeholder="نام خانوادگی"
                required
              /><br />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="ایمیل"
                required
              /><br />
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="رمز عبور"
                required
              /><br />
              <input
                type="password"
                name="password2"
                value={formData.password2}
                onChange={handleChange}
                placeholder="تکرار رمز عبور"
                required
              /><br />
              <label>
              <input type="file" accept="image/*" onChange={handleImageChange} placeholder="نمای پروفایل" style={{color:"grey"}}/>نمای پروفایل
              </label>
              <button type="submit" className='button-register' disabled={loading}>ثبت نام</button>
              <label className="tnc-checkbox">
                <input
                  name="accepted_tnc"
                  type="checkbox"
                  checked={formData.accepted_tnc}
                  onChange={handleCheckBox}
                  required
                  />
                من <Link to={`/${lang}/our-terms-and-conditions`} style={{color:"grey"}}>شرایط و ضوابط</Link> سایت را می‌پذیرم
              </label>
            </form>
            <div className='login-text' >
           !اگر دارای حساب کاربری می‌باشید، لطفا <Link to={`/${lang}/login`}>اینجا وارد شوید</Link> 
            </div>

          </div>
        }
        
        {loading && (
          <div className="loading-overlay">
            <div className="loading-box" style={{ '--spinner-size': '60px' }}>
              <div className="spinner" />
              <span>{setlang === "en" ? 'Loading...':'... در حال بارگذاری'}</span>
            </div>
          </div>
        )}

      </div> 
      <Footer />
    </>
  );
}

export default Register;
